import React, { useState } from 'react';
import { Pane } from 'evergreen-ui';
import { useMutation } from '@apollo/react-hooks';
import { onCompleted } from 'lib/formHelpers';
import FormBuilder from 'components/shared/FormBuilder';
import { IndividualForm } from './Form';
import { IND_SIGNUP_MUTATION } from './queries';

const WaitlistForm = ({ onSignup, currentUser, zipCode }: any) => {
  const [errors, setErrors] = useState({});
  const [signUp, { loading }] = useMutation(IND_SIGNUP_MUTATION, {
    onCompleted: (response: any) =>
      onCompleted({
        response,
        setErrors,
        onComplete: onSignup
      })
  });

  return (
    <Pane>
      <FormBuilder
        isInline
        saveButtonTitle="Signup for waitlist"
        initialValues={{
          zipCode: zipCode.zipCode,
          state: zipCode.state,
          name: currentUser && currentUser.name,
          email: currentUser && currentUser.email,
          affiliatedAgencies: ['']
        }}
        form={IndividualForm}
        errors={errors}
        isLoading={loading}
        showErrorHint={false}
        saveButtonProps={{
          width: '100%',
          justifyContent: 'center',
          marginTop: 16,
          display: 'flex',
          height: 40,
          intent: null
        }}
        onSubmit={(input: any) => {
          setErrors({});
          signUp({ variables: { input } });
        }}
      />
    </Pane>
  );
};

export default WaitlistForm;
